import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "alt"]

import { ref, onMounted, watch } from 'vue';
import JsBarcode from 'jsbarcode';
import { makeEan13FromMembership } from '@/utils/barcode-utils';
import { useAccountStore } from '@/store';

interface Props {
  membershipNumber: string; // raw, may include spaces
  format?: string; // defaults to EAN13
  width?: number;
  height?: number;
  fontSize?: number;
  alt?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseBarcode',
  props: {
    membershipNumber: { default: '' },
    format: { default: 'EAN13' },
    width: { default: 3 },
    height: { default: 90 },
    fontSize: { default: 18 },
    alt: { default: 'Membership Barcode' }
  },
  setup(__props: any) {

const accountStore = useAccountStore();

const props = __props;

const barcodeImage = ref<string | null>(null);

const generate = async () => {
  // Compute EAN13 from RACQ-style membership number
  let eanFromApi = await accountStore.getMembershipNumber();
  let ean = null;
  if (eanFromApi && !eanFromApi.data) {
    ean = makeEan13FromMembership(props.membershipNumber);
  } else {
    ean = eanFromApi?.data;
  }
  if (!ean) {
    barcodeImage.value = null;
    return;
  }

  const formattedText = `${ean.slice(0, 1)} ${ean.slice(1, 7)} ${ean.slice(7)}`;
  const canvas = document.createElement('canvas');

  JsBarcode(canvas, ean, {
    format: props.format,
    displayValue: true,
    flat: true,
    font: 'Arial',
    text: formattedText,
    width: props.width,
    height: props.height,
    fontSize: props.fontSize,
  });

  barcodeImage.value = canvas.toDataURL('image/png');
};

onMounted(generate);
watch(() => props.membershipNumber, generate);

return (_ctx: any,_cache: any) => {
  return (barcodeImage.value)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: barcodeImage.value,
        alt: _ctx.alt
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})